import { useLocation, useParams } from "react-router-dom";
import "./CadastroUsers.css";
import { useEffect, useState } from "react";
import FormUsers from "../FormUsers/FormUsers";
import CadastroContainer from "../../../components/CadastroContainer/CadastroContainer";
import UserService from "../../../services/UserService";

const CadastroUsers = () => {
	const { userId } = useParams();
	const { state } = useLocation();
	const [user, setUser] = useState(state);
	const [type, setType] = useState("");

	async function loadUser(id) {
		const response = await UserService.getUser(id);
		if (response.data) {
			setUser(response.data);
		}
	}

	useEffect(() => {
		setType(userId || state ? "edicao" : "cadastro");

		if (user) {
			setUser(state);
			return;
		}

		if (userId) {
			loadUser(userId);
		}
	}, [state, userId]);

	return (
		<CadastroContainer>
			<FormUsers user={user} type={type} />
		</CadastroContainer>
	);
};

export default CadastroUsers;
